import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { StarRating } from '../../marketplace/components/StarRating';
import { deleteCommunityApi } from '../../../api/communities';
import { fetchCommunities } from '../../../store/slices/communitySlice';
import { Button, Modal } from 'react-bootstrap';

export const CommunityCard = ({ community }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { filters } = useSelector((state) => state.community);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const ownerId = typeof community.owner === 'object' ? community.owner?._id : community.owner;
  const isOwner = user && ownerId === user._id;

  const handleEdit = (e) => {
    e.stopPropagation();
    navigate(`/edit-community/${community._id}`);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      await deleteCommunityApi(community._id);
      const params = {
        search: filters.search,
        type: filters.type,
        category: filters.selectedCategory,
      };
      dispatch(fetchCommunities(params));
      setShowDeleteModal(false);
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to delete community');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleClick = () => {
    navigate(`/community-detail/${community._id}`);
  };

  return (
    <>
      <div className="community-card bg-white border h-100 overflow-hidden pointer" onClick={handleClick}>
        <div className="position-relative">
          <img src={community.coverImage} alt={community.title || community.name} className="img-fluid w-100 object-fit-cover" style={{ height: "170px" }} />
          <div className="card-actions position-absolute top-0 end-0 m-2 d-flex gap-2">
            {community.rank && (
              <span className="badge bg-dark text-white fw-medium">
                #{typeof community.rank === 'string' ? community.rank : `${community.rank}`}
              </span>
            )}
            {isOwner && (
              <>
                <Button 
                  variant="light" 
                  size="sm" 
                  className="rounded-circle shadow-sm" 
                  onClick={handleEdit}
                  title="Edit Community"
                >
                  <i className="bi bi-pencil-square text-primary"></i>
                </Button>
                <Button 
                  variant="light" 
                  size="sm" 
                  className="rounded-circle shadow-sm" 
                  onClick={(e) => { e.stopPropagation(); setShowDeleteModal(true); }}
                  title="Delete Community"
                >
                  <i className="bi bi-trash text-danger"></i>
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="item-info small">
          <div className="flex-grow-1 p-3">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
              <span className={`course-category badge bg-${community.categoryColor || 'primary'} bg-opacity-10 fw-medium rounded-0 text-${community.categoryColor || 'primary'} text-uppercase`}>
                {typeof community.category === 'object' ? community.category.name : (community.categoryName || community.category || 'COMMUNITY')}
              </span>
              <span className="course-price text-base fw-semibold text-primary">
                {typeof community.price === 'string'
                  ? (community.price.includes('/m') ? community.price : `${community.price}/m`)
                  : (community.subscriptionFee > 0 ? `$${community.subscriptionFee}/m` : 'Free')}
              </span>
            </div>
            <div className="course-title fw-medium text-truncate-2 text-gray-900">{community.title || community.name}</div>
          </div>
          <div className="border-top d-flex flex-wrap align-items-center justify-content-between gap-2 text-gray-700 fw-medium px-3 py-2">
            <span className="ratings d-flex align-items-center gap-1">
              <StarRating rating={community.rating || 5} />
              <span className="rating-number">{(community.rating || 5).toFixed(1)}</span>
            </span>
            <span>
              {community.membersCount || 0} <span className="fw-normal text-gray-500">members</span>
            </span>
          </div>
        </div>
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} onClick={(e) => e.stopPropagation()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Community</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the community <strong>{community.name}</strong>? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

